<template>
  <div :class="radioLabel ? '':'mt-2'">
    <label class="label-style" for="validationCustom01" v-if="radioLabel">{{radioLabel}}</label>
    <div class="form-row no-margin">
      <b-form-radio-group v-model="defaultValue">
        <b-form-radio
          v-for="(radioData, index) in formRadio"
          :key="index"
          :value="radioData.keyDesc"
          :name="radioData.keyDesc"
          class="margin-right"
          @change="onChange(radioData)"
        >{{radioData.keyDesc}}</b-form-radio>
      </b-form-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  props: ["radioLabel", "formRadio", "defaultValue"],
  methods: {
    onChange(radioData) {
      this.$emit("radioInputChange", radioData);
    }
  }
};
</script>

<style>
.wo-label {
      margin-top: 45px !important;
}
.invalid-feedback {
  display: block !important;
}
.valid-feedback {
  display: block !important;
}
.margin-right {
  margin-right: 40px;
}
</style>

